// types
import type { FC, PropsWithChildren } from "react";
// components
import { Loading } from "components/common/Loading";
// hooks
import { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
// config
import { paths } from "routes/paths";
import { useAuth } from "hooks";

export const AuthGuard: FC<PropsWithChildren> = (props) => {
  const { children } = props;
  const { isAuthenticated, isInitialized } = useAuth();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(
    null
  );

  if (!isInitialized) {
    return <Loading />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Navigate to={paths.auth.login} />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
};
